import { sliderPagination } from '~/js/helpers';

const courseOverviews = [...document.querySelectorAll('.course-overview')];

courseOverviews.forEach((block) => {
	const swiperEl = block.querySelector('.swiper-course-overview');

	if (swiperEl) {
		initSlider(block, swiperEl);
		return;
	}

	initViewToggle(block);
});

function initViewToggle(block) {
	const gridBtn = block.querySelector('[data-view="grid"]');
	const listBtn = block.querySelector('[data-view="list"]');
	const gridContainer = block.querySelector('.course-overview__grid');
	const listContainer = block.querySelector('.course-overview__list');

	if (!gridBtn || !listBtn) {
		return;
	}

	const setView = (view) => {
		const isGrid = view === 'grid';

		gridContainer?.classList.toggle('hidden', !isGrid);
		listContainer?.classList.toggle('hidden', isGrid);

		gridBtn.classList.toggle('bg-white', isGrid);
		gridBtn.classList.toggle('shadow-sm', isGrid);

		listBtn.classList.toggle('bg-white', !isGrid);
		listBtn.classList.toggle('shadow-sm', !isGrid);
	};

	gridBtn.addEventListener('click', () => setView('grid'));
	listBtn.addEventListener('click', () => setView('list'));
}

async function initSlider(block, swiperEl) {
	const [{ default: Swiper }, { Navigation, Pagination, A11y }] = await Promise.all([
		import('swiper'),
		import('swiper/modules'),
	]);

	await import('swiper/css');

	const slidesPerView = Number(swiperEl.dataset.swiperColumns) || 3;

	new Swiper(swiperEl, {
		modules: [Navigation, Pagination, A11y],
		a11y: true,
		grabCursor: true,
		loop: false,
		slidesPerView: 1.05,
		spaceBetween: 32,
		keyboard: {
			enabled: true,
		},
		navigation: {
			nextEl: swiperEl.querySelector('.swiper-button-next'),
			prevEl: swiperEl.querySelector('.swiper-button-prev'),
		},
		pagination: sliderPagination(swiperEl.querySelector('.swiper-pagination')),
		breakpoints: {
			760: { slidesPerView, spaceBetween: 32 },
			1024: { slidesPerView },
		},
	});
}
